import React from "react"
import { Typography } from "@material-ui/core"

import TypographyListGroup from "@/components/TypographyListGroup"
import ClientName from "@/components/ClientIdentification/ClientName"
import ClientNickname from "@/components/ClientIdentification/ClientNickname"

import useStyles from "@/components/ProductReportClient/styles"
import useCustomStyles from "@/styles/custom"

import PhoneNumberRedirect from "@/components/PhoneNumberRedirect"
import { Link } from "react-router-dom"
import clsx from "clsx"

import useContactDisplay from "@/hooks/useContactDisplay"

export type ProductReportClientProps = {
	client?: {
		id: number
		nickname?: string
		name?: string
		phoneNumber?: string
	}
	hidePhoneNumber?: boolean
}

const ProductReportClient: React.FC<ProductReportClientProps> = (props) => {
	const { client, hidePhoneNumber } = props

	const classes = useStyles()
	const customClasses = useCustomStyles()
	const clientExists = !!client
	const { getDisplayName } = useContactDisplay()

	return (
		<TypographyListGroup>
			{clientExists ? (
				<div >
					<Link
						to={`/admin/contacts/client-catalog?nickname=${client.nickname}`}
						target="_blank"
						style={{ textDecoration: "none" }}
					>
						<ClientNickname
							className={clsx({
								[classes.contact]: true
							})}
						>
							{getDisplayName(client?.nickname, client?.phoneNumber) || "Sem nome"}
						</ClientNickname>
					</Link>

					{client?.phoneNumber && !hidePhoneNumber && (
						<PhoneNumberRedirect phoneNumber={client.phoneNumber} clientId={client.id} />
					)}

					{client?.name && (
						<ClientName
							className={customClasses.italicText}
							name={client.name}
							phone={client?.phoneNumber}
						/>
					)}
				</div>
			) : (
				<Typography
					className={classes.unknown}
				>
					Desconhecido
				</Typography>
			)}
		</TypographyListGroup>
	)
}

export default ProductReportClient
